<template lang="pug">
div
  v-navigation-drawer(app disable-route-watcher :width="$vuetify.breakpoint.lgAndUp ? 250 : 250" :value="drawer" @input="drawerChanged" :clipped="$vuetify.breakpoint.lgAndUp")
    v-layout(fill-height column justify-space-between)
      v-list.pb-0
        // Настройки + Аватарка
        wf-settings-drawer

        //- Процессы
        wf-process-drawer

        //- Главная
        //- wf-home-drawer

        //- Задачи
        wf-task-drawer


        //- Отчеты
        wf-report-drawer(v-if="hasOtherGroup")

        v-list-tile(@click="select" :to="{name:'ProcessSearch'}" ripple)
          v-list-tile-action.pl-0
            v-icon search
          v-list-tile-content
            v-list-tile-title {{ $tf("drawer.process.search") }}



      .justify-end
        //- Помощь
        v-divider
        v-list-group(prepend-icon="help" no-action)
          v-list-tile(slot="activator")
            v-list-tile-content
              v-list-tile-title {{ $tf("drawer.help.title") }}
          v-list-tile(href="mailto:Profcouz_Office@kazzinc.com" ripple)
            v-list-tile-content
              v-list-tile-title Profcouz_Office@kazzinc.com
            v-list-tile-action
              v-icon email

        //- Структура компании
        v-divider
        v-list-tile(href="/static/link/profsoyuzlist9.htm" ripple)
          v-list-tile-action.pl-0
            v-icon people
          v-list-tile-content
            v-list-tile-title {{ $tf("drawer.profsoyuz.title") }}

        //- Коллективный договор
        v-divider
        v-list-tile(@click="select" :to="{name:'Contracts'}" ripple)
          v-list-tile-action.pl-0
            v-icon file_copy
          v-list-tile-content
            v-list-tile-title {{ $tf("drawer.contracts.title") }}

        //- Загрузка процесса
        v-divider
        v-list-tile(@click="toggleProcessDeployDialog(true)" ripple v-if="hasPermissionToDeploy")
          v-list-tile-action.pl-0
            v-icon cloud_upload
          v-list-tile-content
            v-list-tile-title {{ $tf("drawer.process.processDeploy") }}

        //- Выход
        v-divider
        v-list-tile.mb-2(@click="logoutConfirm" ripple)
          v-list-tile-action.pl-0
            v-icon exit_to_app
          v-list-tile-content
            v-list-tile-title {{ $tf("drawer.logout.title") }}
  //- Выгрузка процесса
  wf-process-deploy

  v-container.pa-0(fluid fill-height)
    router-view

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import HomeDrawer from '@/components/home/HomeDrawer'
import TaskDrawer from '@/components/task/TaskDrawer'
import ProcessDrawer from '@/components/process/ProcessDrawer'
import ReportDrawer from '@/components/report/ReportDrawer'
import ProcessDeploy from '@/components/process/ProcessDeploy'
import SettingsDrawer from '@/components/settings/SettingsDrawer'
import camundaAPI from '@/services/camunda'

// Yandex metrics, Google Analytics, Announcekit etc
import tools from '@/services/tools'
import lodash from 'lodash'

export default {
  name: 'Drawer',

  components: {
    'wf-home-drawer': HomeDrawer,
    'wf-task-drawer': TaskDrawer,
    'wf-report-drawer': ReportDrawer,
    'wf-process-drawer': ProcessDrawer,
    'wf-process-deploy': ProcessDeploy,
    'wf-settings-drawer': SettingsDrawer
  },

  data() {
    return {
      hasPermissionToDeploy: true,
    }
  },

  computed: {
    ...mapGetters({
      drawer: 'tools/drawer',
      profile: 'auth/profile',
      groups: 'auth/groups',
      newsUnreadCount: 'tools/newsUnreadCount',
    }),
    hasOtherGroup() {
      const result = lodash.some(this.groups, group => group.id !== 'allUsers')
      return result
    },
  },

  created() {
    // Yandex metrics, Google Analytics, Announcekit etc
    tools.init(this.profile.userName)
    camundaAPI.user.authorization('deployment', 'create').then((result) => {
      this.hasPermissionToDeploy = !!(result.data && result.data.length > 0)
    })
  },

  methods: {
    ...mapActions({
      toggleDrawer: 'tools/toggleDrawer',
      logout: 'auth/logout',
      showConfirm: 'tools/showConfirm',
      setAppLoaded: 'tools/setAppLoaded',
      setLocale: 'tools/setLocale',
      toggleDrawer: 'tools/toggleDrawer',
      toggleProcessDeployDialog: 'process/toggleProcessDeployDialog',
    }),

    drawerChanged(value) {
      if (value !== this.drawer) {
        this.toggleDrawer()
      }
    },

    openNews() {
      // eslint-disable-next-line no-undef
      if (window.cordova !== undefined && device.platform === 'iOS') {
        window.location = 'https://announcekit.app/opera-build/novosti-opera-build'
      } else {
        window.announcekit.widget$announce.open()
      }
    },

    select() {
      if (!this.$vuetify.breakpoint.lgAndUp) {
        this.toggleDrawer()
      }
    },

    logoutConfirm() {
      this.showConfirm({ title: this.$tf('drawer.logout.confirm'), resolveText: this.$tf('drawer.logout.logout'), rejectText: this.$tf('drawer.logout.cancel') }).then(() => {
        this.toggleDrawer()
        this.logout()
      }).catch(() => {})
    },
  },

}
</script>

<style lang="stylus">
.active-filter
  .v-list__tile__title
    color #1976d2 !important

.v-navigation-drawer
  .v-list__tile__action
    padding-left 10px
  .v-chip--x-small
    font-size 10px
    height 16px
    .v-chip__content
      line-height 1
      padding 8px
.lang-icon
  width 14px
.lang-btn
  min-width 45px
  border 1px solid #2196F3
  color #2196F3
  margin-left -1px !important
  text-align center
  padding 2px 28px !important
  transition all 0.4s
  &:hover
    cursor pointer
    background-color: #2196F3
    color: #fff
  &__active
    background-color: #2196F3
    color: #fff
.drawer-avatar
  border 2px #000 solid
.lg-tile > .v-list__tile > .lang-btn
  padding 2px 36px !important
</style>



// WEBPACK FOOTER //
// src/components/drawer/Drawer.vue